import { KioskType } from 'types/KioskTypes';

import SHAREBOX_KIOSK_BREAKDOWN_STEPS from './sharebox';
import PARTTEAM_KIOSK_BREAKDOWN_STEPS from './partteam';

export default {
  [KioskType.PARTTEAM]: PARTTEAM_KIOSK_BREAKDOWN_STEPS,
  [KioskType.SHAREBOX]: SHAREBOX_KIOSK_BREAKDOWN_STEPS,
};
